// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/named */
import { takeLatest, spawn, put } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty } from 'utils/functions';
import { appActions } from 'commons/reducer';
import { PRODUCTS } from '../reducer';

function* getStateFromApi() {
  yield takeLatest(PRODUCTS.GET_STATE_FROM_API, function* (action) {
    const response = yield apiRequest('api/v1/products', { method: 'get' });
    yield put(apiSuccess(PRODUCTS.GET_STATE_FROM_API_SUCCESS, response));
  });
}

function* createProduct() {
  yield takeLatest(PRODUCTS.CREATE_PRODUCT, function* (action) {
    yield put(appActions.setLoader('create-edit-product', true));
    const response = yield apiRequest('api/v1/products', {
      method: 'post',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(PRODUCTS.CREATE_PRODUCT_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-product', false));
  });
}

function* editProduct() {
  yield takeLatest(PRODUCTS.EDIT_PRODUCT, function* (action) {
    yield put(appActions.setLoader('create-edit-product', true));
    const response = yield apiRequest(`api/v1/products/${action.id}`, {
      method: 'put',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(PRODUCTS.EDIT_PRODUCT_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-product', false));
  });
}

function* deleteProduct() {
  yield takeLatest(PRODUCTS.DELETE_PRODUCT, function* (action) {
    yield put(appActions.setLoader('delete-product', true));
    const response = yield apiRequest(`api/v1/products/${action.id}`, { method: 'delete' });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    }
    const item = Object.values(response)[0];
    yield put(apiSuccess(PRODUCTS.DELETE_PRODUCT_SUCCESS, { item, type: 'products' }));
    yield put(appActions.setLoader('delete-product', false));
  });
}

function* exportProducts() {
  yield takeLatest(PRODUCTS.EXPORT_PRODUCTS, function* (action) {
    yield put(appActions.setLoader('export-products', true));
    const response = yield apiRequest(
      'api/v1/products/export',
      { method: 'get' },
      false,
      'productos.xlsx',
    );
    yield put(apiSuccess(PRODUCTS.EXPORT_PRODUCTS_SUCCESS, response));
    yield put(appActions.setLoader('export-products', false));
  });
}

function* importProducts() {
  yield takeLatest(PRODUCTS.IMPORT_PRODUCTS, function* (action) {
    yield put(appActions.setLoader('import-products', true));
    yield put(
      appActions.showImportModal({
        title: 'Importando Productos',
      }),
    );
    try {
      const tenant = window.location.hostname.split('.')[0];
      const formData = new FormData();
      formData.append('file', action.payload.file);
      formData.append('type', action.payload.type);
      formData.append('socketId', action.payload.socketId);
      formData.append('tenant', tenant);

      const response = yield apiRequest('api/v1/products/import', {
        method: 'post',
        body: formData,
      });

      if (truthty(response.error)) {
        yield put({ type: PRODUCTS.IMPORT_PRODUCTS_ERROR, payload: response.errorMsg });
        yield put(appActions.setError(response.errorMsg));
      } else {
        yield put({ type: PRODUCTS.IMPORT_PRODUCTS_SUCCESS, payload: response });
      }
    } catch (error) {
      yield put({
        type: PRODUCTS.IMPORT_PRODUCTS_ERROR,
        payload: 'Error al iniciar importación',
      });
    }
  });
}

function* handleImportSocketResponse() {
  yield takeEvery(
    [PRODUCTS.IMPORT_PRODUCTS_SOCKET_SUCCESS, PRODUCTS.IMPORT_PRODUCTS_SOCKET_ERROR],
    function* (action) {
      yield put(appActions.setLoader('import-products', false));
      if (action.type === PRODUCTS.IMPORT_PRODUCTS_SOCKET_SUCCESS) {
        yield put({ type: PRODUCTS.GET_STATE_FROM_API });
        const result = action.payload.importResult;
        const processedCount = result?.processed || 'varios';
        yield put(appActions.setSuccess(`✅ ${processedCount} productos procesados exitosamente`));
      } else if (action.type === PRODUCTS.IMPORT_PRODUCTS_SOCKET_ERROR) {
        const errorMsg = action.payload.error || 'Error desconocido en la importación';
        yield put(appActions.setError(`${errorMsg}`));
      }
    },
  );
}

export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(deleteProduct);
  yield spawn(createProduct);
  yield spawn(editProduct);
  yield spawn(exportProducts);
  yield spawn(importProducts);
  yield spawn(handleImportSocketResponse);
}
